import { colorToCss } from "../../color/color"
import { MorganAttribute } from "../morgan"

/// <reference path="../../color/color.ts" />

type MorganColor = [
    min: number,
    max: number | undefined,
    index: string,
    color: [red: number, green: number, blue: number],
    label?: string,
]

export const morgan: { [key in MorganAttribute]: MorganColor[] } = {

    P2O5: [
        [0, 0.9, "VL", [255, 0, 0]],
        [0.9, 1.8, "VL", [192, 0, 0]],
        [1.8, 3.1, "L", [255, 135, 0]],
        [3.1, 4.5, "L", [255, 255, 0]],
        [4.5, 7, "M-", [63, 242, 0]],
        [7, 9.5, "M-", [37, 142, 0]],
        [9.5, 11.5, "M+", [72, 185, 185]],
        [11.5, 13.5, "M+", [17, 91, 239]],
        [13.5, 22.8, "H", [234, 0, 206]],
        [22.8, 30, "H", [139, 0, 139]],
        [30, undefined, "VH", [83, 0, 83], "> 30.0 mg/l"],
    ],

    K2O: [
        [0, 20, "VL", [255, 0, 0]],
        [20, 40, "VL", [192, 0, 0]],
        [40, 57, "L", [255, 135, 0]],
        [57, 76, "L", [255, 255, 0]],
        [76, 108, "M-", [63, 242, 0]],
        [108, 141, "M-", [37, 142, 0]],
        [141, 171, "M+", [72, 185, 185]],
        [171, 201, "M+", [17, 91, 239]],
        [201, 301, "H", [234, 0, 206]],
        [301, 400, "H", [139, 0, 139]],
        [401.1, undefined, "H", [83, 0, 83], "> 400 mg/l"],
    ],

    MgO: [
        [0, 10, "VL", [255, 0, 0]],
        [10, 20, "VL", [192, 0, 0]],
        [20, 40, "L", [255, 135, 0]],
        [40, 61, "L", [255, 255, 0]],
        [61, 96, "M-", [63, 242, 0]],
        [96, 131, "M-", [37, 142, 0]],
        [131, 166, "M+", [72, 185, 185]],
        [166, 201, "M+", [17, 91, 239]],
        [201, 601, "H", [234, 0, 206]],
        [601, 1000, "H", [139, 0, 139]],
        [1000.1, undefined, "H", [83, 0, 83], "> 1000 mg/l"],
    ]

}

const indexToNumber = {
    "VL": 0,
    "L": 1,
    "M-": 2,
    "M+": 3,
    "H": 4,
    "VH": 5
}

const morganColors = Object.fromEntries(

    Object.entries(morgan)
        .map(e => [
            e[0],
            e[1].map(m => ({
                Value: m[0],
                MinValue: m[0],
                MaxValue: m[1],
                Colour: m[3],
                Index: indexToNumber[m[2]],
            }))
        ])

)


const morganKeys = Object.fromEntries(

    Object.entries(morgan)
        .map(e => [
            e[0],
            e[1].map(a => {

                const l = (a[4] ?? `${a[0]} - ${a[1]} mg/l`)

                return {
                    value: a[0],
                    text: `${l} (${a[2]})`,
                    color: colorToCss(a[3]),
                    minValue: a[0],
                    maxValue: a[1]
                }

            })

        ])

)

export function getMorganColors(a: MorganAttribute) {
    return morganColors[a]
}

export function getMorganColor(attr: MorganAttribute, value: number) {

    const s = morgan[attr]

    let r = s.find(a => (a[0] <= value) && (a[1] > value))

    if (!r) {
        r = s[0][0] > value ? s[0] : s[s.length - 1]
    }

    return r ? r[3] : undefined

}

export function getMorganKey(attr: MorganAttribute) {
    return morganKeys[attr]
}
